export default __webpack_public_path__ + "static/media/closedLock.22b296bf.svg";